export default "__VITE_ASSET__BVd5PgqW__"